export const ItemPriorityName = [
    { id: "0", name: "Basic" },
    { id: "1", name: "Urgent" },
    { id: "2", name: "Top Urgent" },
    { id: "3", name: "Revision" },
  ];

  export function findPriorityName(id){
    if(id != undefined){
      const selectedObj = ItemPriorityName.find((obj) => obj.id === id.trim());
      if (selectedObj) {
        const name = selectedObj.name;
        return name;
      }
    }
    return "N/A";
  };